module.exports = __webpack_public_path__ + "static/media/blub.add65489.png";